export const environment = {
  production: true,
  apiUrl: 'https://gbu.testnir.ru',
  clientId: 2,
  clientSecret: 'N6YSSL2DqyC67SY5gQah2eX6pQXbsZjesQPzOXWK',
  project: null,
  licence: 'XDIR5Z6WXY39',
  defaultLocale: 'ru'
};
